var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbexLogoSmDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2148 18.6609V18.5674C33.4819 17.1286 34.6163 15.0259 34.6163 12.2577C34.6163 10.2324 34.072 8.53087 32.9832 7.15485C31.3208 5.05215 28.343 4 24.05 4H17.6951V10.8672H22.4185C23.1291 10.8672 23.6735 10.9059 24.0516 10.9832C25.5625 11.1846 26.3187 12.0273 26.3187 13.5113C26.3187 15.6462 25.4272 16.7129 23.6425 16.7129H17.6951V23.2079H23.8006C26.128 23.2079 27.2934 24.1198 27.2934 25.9454C27.2934 26.3627 27.2168 26.8735 27.0668 27.4761C26.5828 28.6974 25.6603 29.3081 24.3009 29.3081H17.6951V31.8362C17.6951 31.8362 18.3406 33.0736 19.9166 34.3304C21.8871 35.903 23.2367 36.4766 23.2367 36.4766H26.4084C27.4661 36.4766 28.5467 36.2913 29.6501 35.9191C33.8829 34.2031 36.0001 31.2029 36.0001 26.9186V26.3611C36.0001 22.5714 34.4044 20.0047 31.2148 18.6593V18.6609Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6157 37.9896C22.6157 37.9896 17.198 38.1555 13.3059 37.1662C10.0641 36.3428 7.92737 34.3272 7.37159 32.4968C6.95435 31.124 7.00161 27.5518 7.00161 27.5518V4.0177H15.0662V27.5518C15.0662 27.5518 15.045 30.075 15.529 31.9924C16.595 36.2043 22.6157 37.9912 22.6157 37.9912V37.9896Z",
    fill: "#2BC3EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6922 26.026C33.6922 26.026 32.8887 29.5047 31.2344 31.7782C28.9787 34.8783 26.0237 36.4605 26.0237 36.4605C26.0237 36.4605 27.4222 36.6394 29.5426 35.9482C31.5278 35.3004 32.2498 34.4545 32.2498 34.4545C32.2498 34.4545 32.8529 33.0157 33.3777 30.6632C33.9644 28.032 33.6939 26.026 33.6939 26.026H33.6922Z",
    fill: "#2BC3EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbexLogoSmDark);
export default __webpack_public_path__ + "static/media/ubex-logo-sm-dark.863e4267a3f97effad446866e1b2b643.svg";
export { ForwardRef as ReactComponent };